export function initDarkModeStyles() {
  import('@style-desktop-v2/legacy/darkmode/_darkmode-dir.scss');
}

export function initGameWindowStyles() {
  import('@style-desktop-v2/legacy/components/game-window/_game-window-dir.scss');
}
